import { render } from "./add.vue?vue&type=template&id=4b43a392"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__